import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetReportFiltersService } from '../get-report-filters.service';
import {
  getReportFiltersAction,
  getReportFiltersSuccessAction,
  getReportFiltersFailureAction,
} from './get-report-filters.actions';

@Injectable()
export class GetReportFiltersEffects {
  getReportFilters$ = createEffect(() => this.actions$.pipe(
    ofType(getReportFiltersAction),
    switchMap(action =>
      this.getReportFiltersService.get(action.scope).pipe(
        map(data => getReportFiltersSuccessAction({ data })),
        catchError(error => of(getReportFiltersFailureAction({ error }))),
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private getReportFiltersService: GetReportFiltersService,
  ) {
  }
}
